import { render, staticRenderFns } from "./Dot.vue?vue&type=template&id=282d90b4&"
import script from "./Dot.vue?vue&type=script&lang=js&"
export * from "./Dot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports